import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';

import useStyles from './styles';

export const ReviewApprove = ({ item, companyId, dismissHandler }) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="body1" gutterBottom>
        Your PQF was approved by Safety Council
      </Typography>
      <Grid container justify="center" alignItems="flex-end" className={classes.buttonsWrapper}>
        <Button variant="contained" size="small" onClick={() => dismissHandler(companyId, item.id)}>
          Dismiss
        </Button>
      </Grid>
    </>
  );
};
